"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBucketItemsWarningMessage = exports.setBaseChartUiConfigRecommendations = exports.setBaseChartUiConfig = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var forEach_1 = tslib_1.__importDefault(require("lodash/forEach"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var uiConfig_1 = require("../../constants/uiConfig");
var bucket_1 = require("../../constants/bucket");
var bucketRules_1 = require("./../bucketRules");
var bucketHelper_1 = require("./../bucketHelper");
var translations_1 = require("./../translations");
var propertiesHelper_1 = require("./../propertiesHelper");
var bucket_title_measures_svg_1 = tslib_1.__importDefault(require("../../assets/column/bucket-title-measures.svg"));
var bucket_title_view_svg_1 = tslib_1.__importDefault(require("../../assets/column/bucket-title-view.svg"));
var bucket_title_stack_svg_1 = tslib_1.__importDefault(require("../../assets/column/bucket-title-stack.svg"));
var bucket_title_measures_svg_2 = tslib_1.__importDefault(require("../../assets/bar/bucket-title-measures.svg"));
var bucket_title_view_svg_2 = tslib_1.__importDefault(require("../../assets/bar/bucket-title-view.svg"));
var bucket_title_stack_svg_2 = tslib_1.__importDefault(require("../../assets/bar/bucket-title-stack.svg"));
function setBaseChartBucketWarningMessages(referencePoint, intl) {
    var _a;
    var buckets = (_a = referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.buckets) !== null && _a !== void 0 ? _a : [];
    var updatedUiConfig = cloneDeep_1.default(referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.uiConfig);
    var stackItems = bucketHelper_1.getStackItems(buckets, [bucket_1.ATTRIBUTE, bucket_1.DATE]);
    forEach_1.default(buckets, function (bucket) {
        var _a, _b;
        var localIdentifier = (_a = bucket === null || bucket === void 0 ? void 0 : bucket.localIdentifier) !== null && _a !== void 0 ? _a : "";
        var bucketUiConfig = (_b = updatedUiConfig === null || updatedUiConfig === void 0 ? void 0 : updatedUiConfig.buckets) === null || _b === void 0 ? void 0 : _b[localIdentifier];
        // skip disabled buckets
        if (!(bucketUiConfig === null || bucketUiConfig === void 0 ? void 0 : bucketUiConfig.enabled)) {
            return;
        }
        if (!(bucketUiConfig === null || bucketUiConfig === void 0 ? void 0 : bucketUiConfig.canAddItems)) {
            var warningMessage = void 0;
            if (bucket.localIdentifier === sdk_ui_1.BucketNames.MEASURES) {
                warningMessage = getBucketItemsWarningMessage("dashboard.bucket.metric_stack_by_warning", intl, stackItems);
            }
            else if (bucket.localIdentifier === sdk_ui_1.BucketNames.STACK) {
                warningMessage = translations_1.getTranslation("dashboard.bucket.category_stack_by_warning", intl);
            }
            if (warningMessage) {
                set_1.default(updatedUiConfig, [bucket_1.BUCKETS, localIdentifier, "warningMessage"], warningMessage);
            }
        }
    });
    return updatedUiConfig;
}
function setBaseChartUiConfig(referencePoint, intl, visualizationType) {
    var _a, _b;
    var _c, _d, _e, _f;
    var referencePointConfigured = cloneDeep_1.default(referencePoint);
    var buckets = (_c = referencePointConfigured === null || referencePointConfigured === void 0 ? void 0 : referencePointConfigured.buckets) !== null && _c !== void 0 ? _c : [];
    var measuresCanAddItems = bucketRules_1.hasNoMeasures(buckets) || bucketRules_1.hasNoStacksWithDate(buckets);
    var stackCanAddItems = !bucketRules_1.hasMoreThanOneMasterMeasure(buckets, sdk_ui_1.BucketNames.MEASURES);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG], bucketHelper_1.setBucketTitles(referencePoint, visualizationType, intl));
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.MEASURES, "canAddItems"], measuresCanAddItems);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.VIEW, "canAddItems"], true);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.STACK, "canAddItems"], stackCanAddItems);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, uiConfig_1.OPEN_AS_REPORT, uiConfig_1.SUPPORTED], !propertiesHelper_1.hasColorMapping(referencePointConfigured.properties));
    var iconsMap = {
        column: (_a = {},
            _a[sdk_ui_1.BucketNames.MEASURES] = bucket_title_measures_svg_1.default,
            _a[sdk_ui_1.BucketNames.VIEW] = bucket_title_view_svg_1.default,
            _a[sdk_ui_1.BucketNames.STACK] = bucket_title_stack_svg_1.default,
            _a),
        bar: (_b = {},
            _b[sdk_ui_1.BucketNames.MEASURES] = bucket_title_measures_svg_2.default,
            _b[sdk_ui_1.BucketNames.VIEW] = bucket_title_view_svg_2.default,
            _b[sdk_ui_1.BucketNames.STACK] = bucket_title_stack_svg_2.default,
            _b),
    };
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.MEASURES, "icon"], (_d = iconsMap[visualizationType]) === null || _d === void 0 ? void 0 : _d[sdk_ui_1.BucketNames.MEASURES]);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.VIEW, "icon"], (_e = iconsMap[visualizationType]) === null || _e === void 0 ? void 0 : _e[sdk_ui_1.BucketNames.VIEW]);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.STACK, "icon"], (_f = iconsMap[visualizationType]) === null || _f === void 0 ? void 0 : _f[sdk_ui_1.BucketNames.STACK]);
    set_1.default(referencePointConfigured, uiConfig_1.UICONFIG, setBaseChartBucketWarningMessages(referencePointConfigured, intl));
    return referencePointConfigured;
}
exports.setBaseChartUiConfig = setBaseChartUiConfig;
function setBaseChartUiConfigRecommendations(referencePoint, visualizationType, weekFiltersEnabled) {
    if (visualizationType === sdk_ui_1.VisualizationTypes.COLUMN) {
        var newReferencePoint = cloneDeep_1.default(referencePoint);
        var buckets = newReferencePoint === null || newReferencePoint === void 0 ? void 0 : newReferencePoint.buckets;
        var filters = newReferencePoint === null || newReferencePoint === void 0 ? void 0 : newReferencePoint.filters;
        var percentEnabled = bucketRules_1.percentRecommendationEnabled(buckets, filters);
        var comparisonAndTrending = bucketRules_1.comparisonAndTrendingRecommendationEnabled(buckets);
        var overTimeComparison = bucketRules_1.overTimeComparisonRecommendationEnabled(newReferencePoint, weekFiltersEnabled);
        var previousPeriod = bucketRules_1.previousPeriodRecommendationEnabled(buckets);
        set_1.default(newReferencePoint, [uiConfig_1.UICONFIG, uiConfig_1.RECOMMENDATIONS, "percent"], percentEnabled);
        set_1.default(newReferencePoint, [uiConfig_1.UICONFIG, uiConfig_1.RECOMMENDATIONS, "comparison"], comparisonAndTrending);
        set_1.default(newReferencePoint, [uiConfig_1.UICONFIG, uiConfig_1.RECOMMENDATIONS, "trending"], comparisonAndTrending);
        set_1.default(newReferencePoint, [uiConfig_1.UICONFIG, uiConfig_1.RECOMMENDATIONS, "overTimeComparison"], overTimeComparison);
        set_1.default(newReferencePoint, [uiConfig_1.UICONFIG, uiConfig_1.RECOMMENDATIONS, "previousPeriod"], previousPeriod);
        return newReferencePoint;
    }
    return referencePoint;
}
exports.setBaseChartUiConfigRecommendations = setBaseChartUiConfigRecommendations;
function getBucketItemsIcons(bucket, intl) {
    var attributeUsed = bucket.find(function (x) { return !bucketHelper_1.isDateBucketItem(x); });
    var dateUsed = bucket.find(function (x) { return bucketHelper_1.isDateBucketItem(x); });
    var orString = intl.formatMessage({ id: "or" });
    if (attributeUsed && dateUsed) {
        return "<span class=\"attr-field-icon\" /> " + orString + " <span class=\"date-field-icon\" />";
    }
    else if (attributeUsed) {
        return '<span class="attr-field-icon" />';
    }
    else {
        return '<span class="date-field-icon" />';
    }
}
function getBucketItemsWarningMessage(messageId, intl, bucketItems) {
    var icons = getBucketItemsIcons(bucketItems, intl);
    return translations_1.getTranslation(messageId, intl, {
        icons: icons,
    });
}
exports.getBucketItemsWarningMessage = getBucketItemsWarningMessage;
//# sourceMappingURL=baseChartUiConfigHelper.js.map